<script setup lang="ts">
import LoadingIcon from '@/assets/icons/loading.svg?component'
import HeaderComponent from '@/components/Navigation/HeaderComponent.vue'
import { useUserStore } from '@/stores/user'
import { BoxComponent, TypographyComponent } from '@/ui-library'

const userStore = useUserStore()
</script>
<template>
  <HeaderComponent />
  <BoxComponent :mt="24" :ml="24">
    <el-icon v-if="userStore.isLoading" :size="24">
      <LoadingIcon />
    </el-icon>
    <TypographyComponent v-if="!userStore.isLoading" variant="body-medium"> Hello, {{ userStore.name }} </TypographyComponent>
  </BoxComponent>
</template>
